import React from "react";

export enum IconSize {
  XxLarge = "xxlarge",
}

export interface IconProps {
  icon: string;
  size: IconSize;
}

const Icon = ({ icon, size }: IconProps) => {
  return <i className={`c-icon  c-icon--[${icon}]  c-icon--${size}`}></i>;
};

export default Icon;
